export class UpdateDimensionError extends Error {
}
